import * as ko from 'knockout'
import '../../../../AppUtils/Framework/CustomBindings/StickyBinding'
import { InfoToolbarViewModel, Params } from './InfoToolbarViewModel'
import template from './info-toolbar-wrapper.tpl.html'

if (!ko.components.isRegistered('info-toolbar')) {
  ko.components.register('info-toolbar', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new InfoToolbarViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
